import { fork } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import { TOGGLE_SRP_MAP } from 'app/constants';
import handleToggleMap from './handleToggleMap';

export default function* watchToggleMap() {
  yield fork(takeLatest, TOGGLE_SRP_MAP, handleToggleMap);
}
